import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 9,
	viewBox: "0 0 8 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 0.671875C0 0.443359 0.175781 0.25 0.421875 0.25H7.45312C7.68164 0.25 7.875 0.443359 7.875 0.671875C7.875 0.917969 7.68164 1.09375 7.45312 1.09375H0.421875C0.175781 1.09375 0 0.917969 0 0.671875ZM0 3.48438C0 3.25586 0.175781 3.0625 0.421875 3.0625H7.45312C7.68164 3.0625 7.875 3.25586 7.875 3.48438C7.875 3.73047 7.68164 3.90625 7.45312 3.90625H0.421875C0.175781 3.90625 0 3.73047 0 3.48438ZM7.875 6.29688C7.875 6.54297 7.68164 6.71875 7.45312 6.71875H0.421875C0.175781 6.71875 0 6.54297 0 6.29688C0 6.06836 0.175781 5.875 0.421875 5.875H7.45312C7.68164 5.875 7.875 6.06836 7.875 6.29688Z",
		fill: "white",
		fillOpacity: .6
	})
});
export { SvgList as ReactComponent };
